import { useSelector } from 'react-redux';
import { selectUserRoles } from 'store/authorization/Selector';

export const useHasRole = (role: string): boolean => {
  const roles = useSelector(selectUserRoles);
  return roles.includes(role);
};

export const useIsAdmin = (): boolean => {
  const roles = useSelector(selectUserRoles);
  return roles.includes('Admin') || roles.includes('Administrators');
};
export const useIsTrafficManager = (): boolean => useHasRole('TrafficManager');
export const useCanEditSrm = (): boolean => {
  const roles = useSelector(selectUserRoles);
  return roles.includes('Admin') || roles.includes('Administrators') || roles.includes('TrafficManager');
};
